import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Wrapper, Paragraph} from '../Modal/modal.style';
import {Button} from '../../styles/components/button.style';

const FeedbackErrorModal = ({closeModalCallback}) => (
  <Wrapper>
    <Paragraph>
      <FormattedMessage id="feedback.fulfillmentError" />
    </Paragraph>
    <Button onClick={closeModalCallback}>
      <FormattedMessage id="modal.ok" />
    </Button>
  </Wrapper>
);

FeedbackErrorModal.propTypes = {
  closeModalCallback: PropTypes.func,
  content: PropTypes.string
};

export default FeedbackErrorModal;



// WEBPACK FOOTER //
// ./components/ModalContent/FeedbackErrorModal.js